import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/login"
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/login'),
  },
  {
    name: 'doctors',
    path: '/doctors',
    component: () => import('@/views/sea120/doctors'),
  },
  {
    name: 'doctors-join',
    path: '/doctors-join',
    component: () => import('@/views/sea120/doctors-join'),
  },
  {
    name: 'connect',
    path: '/connect',
    component: () => import('@/views/sea120/connect'),
  },
  {
    name: 'hospital',
    path: '/hospital',
    component: () => import('@/views/sea120/hospital'),
  },
  {
    name: 'fisherybureau',
    path: '/fb',
    mate:{title:'渔业局'},
    component: () => import('@/views/sea120/fishery-bureau'),
  }
]

const router = new VueRouter({
  mode: 'history', // hash
  base: process.env.BASE_URL,
  routes
})

export default router
